import axiosInstance from "@/api/axios-instance";
import { BundleDiscrepanciesResponse } from "@/pages/audit/types/bundle-discrepancy";

export interface BundleDiscrepancyParams {
  page: number;
  limit?: number;
  bundle_id?: string;
  date_from?: string;
  date_to?: string;
  flag?: string;
  user_search?: string;
}

export async function getBundleDiscrepancies(
  params: BundleDiscrepancyParams,
): Promise<BundleDiscrepanciesResponse> {
  const response = await axiosInstance.get("/audit/bundle-discrepancies", {
    params,
  });
  return response.data;
}
